var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppButton',{attrs:{"outlined":"","color":"stroke"},on:{"click":function($event){return _vm.setToday()}}},[_c('span',{staticClass:"grey-light--text"},[_vm._v(_vm._s(_vm.Label))])])}
var staticRenderFns = []

export { render, staticRenderFns }